/* global appdata, modalpromo */
import Cookies from 'js-cookie'
import 'modaal/dist/js/modaal'
import gsap from 'gsap'
import debounce from 'lodash/debounce'
import AOS from 'aos'


export default {
    qtyButton(){
        $(document.body).on( 'click', 'button.plus, button.minus', function() {
            // Get current quantity values
            var qty = $( this ).closest( '.quantity-wrapper' ).find( '.qty' );
            var val   = parseFloat(qty.val());
            var max = parseFloat(qty.attr( 'max' ));
            var min = parseFloat(qty.attr( 'min' ));
            var step = parseFloat(qty.attr( 'step' ));

            // Change the value if plus or minus
            if ( $( this ).is( '.plus' ) ) {
                if ( max && ( max <= val ) ) {
                  qty.val( max );
                }
                else {
                    qty.val( val + step );
                }
            }
            else {
               if ( min && ( min >= val ) ) {
                  qty.val( min );
               }
               else if ( val > 1 ) {
                  qty.val( val - step );
               }
            }
            qty.trigger('change');
        })

    },
    mobileMenu(){
        $('.mobile-menu').css('max-height', window.innerHeight - $('header.banner').outerHeight())
        $(window).on('resize', debounce(function() {
            $('.mobile-menu').css('max-height', window.innerHeight - $('header.banner').outerHeight())
        }, 100));
        var barTop = $('#bar-top');
        var barMidL = $('#bar-mid-l');
        var barMidR = $('#bar-mid-r');
        var barBottom = $('#bar-bottom');
        var circle = $('#circle');
        var menuIcon = $('#menu-icon');

        var tl = gsap.timeline({
            paused:true,
        });

        tl
            .to(barTop, 0.1, {
                y: 5,
                })
            .to(barBottom, 0.1, {
                y: -5,
                },0)
            .to(barTop, 0.15, {
                rotation:45,
                y:0,
                x:10,
                transformOrigin:"left top",
                },0.075)
            .to(barBottom, 0.15, {
                rotation:-45,
                y:0,
                x:10,
                transformOrigin:"left bottom",
                },0.075)
            .to(barMidL, 0.2, {
                opacity:0,
                scaleX:0,
                transformOrigin:"left",
        }, 0)
            .to(barMidR, 0.2, {
                opacity:0,
                scaleX:0,
                transformOrigin:"right",
        }, 0)
            .to(menuIcon, 0.4, {
                rotation:90,
                }, 0.05)
            .fromTo(circle, 0.3, {
                opacity:0,
                scale: 0,
                transformOrigin: "50% 50%",
                    ease: 'bounce.out'
                }, {
                scale: 1,
                opacity: 1,
                ease: 'elastic.out.config(1, 0.8)',
                }, 0.25)
            .to([barTop, barBottom], 0.25, {
                scale: 0.6,
                transformOrigin: "50% 50%",
                ease: 'power4.out'
                }, 0.25);



        $(document.body).on('click', '.brand.mobile-opened, .mobile-menu-link', function(){
            tl.reverse();
            gsap.to('.page-overlay-header', 0.3, { opacity: 0, visibility: 'hidden' })
            $('.mobile-menu').removeClass('opened')
            $('.hamburger-menu').removeClass('opened')
        })
        $(document.body).on('click', '.page-overlay-header', function(e){
            tl.reverse();
            gsap.to('.page-overlay-header', 0.3, { opacity: 0, visibility: 'hidden' })
            $('.mobile-menu').removeClass('opened')
            $('.hamburger-menu').removeClass('opened')
        })

        $(document.body).on('click', '.hamburger-menu', function(e){
            e.preventDefault()

            if ( $(this).hasClass('opened') ) {
                tl.reverse();
                gsap.to('.page-overlay-header', 0.3, { opacity: 0, visibility: 'hidden' })
            }
            else {
                tl.play();
                gsap.to('.page-overlay-header', 0.3, { opacity: 1, visibility: 'visible' })
            }
            $('.brand').toggleClass('mobile-opened')
            $('.mobile-menu').toggleClass('opened')
            $(this).toggleClass('opened')

        })
    },
	onOrder(){
		$(document.body).on( 'change', 'select.orderby', function() {
			$( this ).closest( 'form' ).submit();
		});
	},
    minicartOpen() {
        const app = this

        $(document.body).addClass('overlay-opened')
        gsap.set('.minicart', {display:'block'})
        gsap.to('.minicart', 0.3, { x: 0, onComplete: () => {
            $('.minicart').addClass('minicart--opened')
        } })
        gsap.to('.page-overlay', 0.3, { opacity: 1, visibility: 'visible' })

    },
    minicartUpdateQty(){

        const app = this

        $(document.body).on( 'click', '.minicart-qty', function(e) {
            e.preventDefault()
            // Get current quantity values
            var qty = $( this ).parent().find( 'input.qty-minicart' );
            var val   = parseFloat(qty.val());
            var max = parseFloat(qty.attr( 'max' ));
            var min = parseFloat(qty.attr( 'min' ));
            var step = parseFloat(qty.attr( 'step' ));
            var qtytosend = val;
            // Change the value if plus or minus
            if ( $( this ).is( '.minicart-qty--up' ) ) {
                if ( max && ( max <= val ) ) {
                    qtytosend = max;
                }
                else {
                    qtytosend = val + step;
                }
            }
            else {
               if ( min && ( min >= val ) ) {
                    qtytosend = min;
               }
               else if ( val > 1 ) {
                    qtytosend = val - step;
               }
            }
            var item_hash = qty.attr( 'name' ).replace(/cart\[([\w]+)\]\[qty\]/g, "$1");
            var currentVal = parseFloat(qtytosend);
            const $row = $(this).closest('.minicart__list__item')
            $row.block({
                message: null,
                overlayCSS: {
                    opacity: 0.85,
                    backgroundColor: '#fff',
                },
            });

            $.ajax({
                type: 'POST',
                url: appdata.ajax_url,
                data: {
                    action: 'woocommerce_ajax_modify_cart',
                    hash: item_hash,
                    quantity: currentVal
                },
                success: function(response) {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
                },
                complete: function(){
                    $row.unblock();
                }
            });



        })
        $( document ).on( 'change', 'input.qty-minicart', function() {




        });

    },

    minicartClose() {

        $(document.body).removeClass('overlay-opened')
        gsap.to('.minicart', 0.3, { x: '100%', display:'none', onComplete: () => {
            $('.minicart').removeClass('minicart--opened')
        } })
        gsap.to('.page-overlay', 0.3, { opacity: 0, visibility: 'hidden' })

    },
    headerFunctions() {
        const app = this
        $(document.body).on('click', '.cart-header', function(e){
            e.preventDefault()
            $(document.body).trigger('minicartOpen')
        })
        $(document.body).on('click', '.page-overlay, .close-minicart', function(e){
            e.preventDefault()
            if($('.minicart').hasClass('minicart--opened')){
                $(document.body).trigger('minicartClose')
            }
        })


        let lastScroll = 0;

        window.addEventListener("scroll", () => {
          const currentScroll = window.pageYOffset;
          if (currentScroll == 0) {
            $('.header-app__banners').removeClass('header-app__banners--hide')
            $('.main-content').addClass('main-content__withbanner--active')
            return;
          }

          if (currentScroll > lastScroll && !$('.header-app__banners').hasClass('header-app__banners--hide')) {
            $('.header-app__banners').addClass('header-app__banners--hide')
            $('.main-content').removeClass('main-content__withbanner--active')
          } else if (currentScroll < lastScroll && $('.header-app__banners').hasClass('header-app__banners--hide')) {
            $('.header-app__banners').removeClass('header-app__banners--hide')
            $('.main-content').addClass('main-content__withbanner--active')
          }
          lastScroll = currentScroll;
        })


    },
    cookiesPopup() {
        if(Cookies.get('cookie') !== 'accept'){
            $('#cookies-popup').addClass('show');
        }
        $(document.body).on('click', '#btnCloseCookie', function(e){
            e.preventDefault()
            Cookies.set('cookie', 'accept');
            $('#cookies-popup').removeClass('show');
        })

    },
    toggleMenuMobile() {
        $(document.body).toggleClass('menu-opened-overflow')
        $('.nav-primary').toggleClass('menu-opened')
    },
    iconBurger() {
        const App = this
        function t(i) {
            var e = i.parentNode;
            if ('svg' !== e.tagName) e = t(e);
            return e;
        }

        function i(t, i, e, n) {
            return 1 > (t /= n / 2) ? e / 2 * t * t * t * t + i : -e / 2 * ((t -= 2) * t * t * t - 2) + i
        }

        function e(t) {
            this.element = t, this.topLine = this.element.getElementsByTagName('path')[0], this.bottomLine = this.element.getElementsByTagName('path')[1], this.time = {
                start: null,
                total: 250,
            }, this.status = {
                interacted: !1,
                animating: !1,
            }, this.init()
        }

        if (!window.requestAnimationFrame) {
            var n = null;
            window.requestAnimationFrame = function(t) {
                var e = (new Date).getTime();
                n || (n = e);
                var a = Math.max(0, 16 - (e - n)),
                    s = window.setTimeout(function() {
                        t(e + a)
                    }, a);
                return n = e + a, s
            }
        }

        e.prototype.init = function() {
              var t = this;

                this.element.addEventListener('click', function() {
                if(!t.status.animating){
                  App.toggleMenuMobile()
                  window.requestAnimationFrame(t.triggerAnimation.bind(t))
                }
                })


        }, e.prototype.triggerAnimation = function(t) {
            var i = this.getProgress(t),
                e = this.status.interacted ? this.time.total - i : i;
            this.animateIcon(e), this.checkProgress(i)
        }, e.prototype.getProgress = function(t) {
            return this.time.start || (this.time.start = t), t - this.time.start
        }, e.prototype.checkProgress = function(t) {
            var i = this;
            this.time.total > t ? window.requestAnimationFrame(i.triggerAnimation.bind(i)) : (this.status = {
                interacted: !this.status.interacted,
                animating: !1,
            }, this.time.start = null)
        }, e.prototype.animateIcon = function(t) {
            if (t > this.time.total)(t = this.time.total);
            if (0 > t)(t = 0);
            var e = i(Math.min(t, this.time.total / 2), 0, 7, this.time.total / 2).toFixed(2),
                n = i(Math.max(t - this.time.total / 2, 0), 0, 45, this.time.total / 2).toFixed(2);
            this.topLine.setAttribute('transform', 'translate(0 ' + e + ') rotate(' + n + ' 16 9)'), this.bottomLine.setAttribute('transform', 'translate(0 ' + -e + ') rotate(' + -n + ' 16 23)')
        };
        var a = document.getElementsByClassName('vital-menu-svg');
        if (a)
            for (var s = 0; a.length > s; s++) new e(t(a[s]))
    },
    modalPromo(){
        if(modalpromo.active){
            $('.modal-promo').modaal({
                after_close: () => {
                    if(modalpromo.cookies){
                        Cookies.set('modalpromo', 'closed', { expires: modalpromo.expires });
                    }
                },
            })

            if(modalpromo.cookies){
                if(Cookies.get('modalpromo') !== 'closed'){
                    $('.modal-promo').modaal('open')
                }

            } else {
                $('.modal-promo').modaal('open')
            }

            $(document.body).on('click', '.link-inner-promo-modal', function(){
                $('.modal-promo').modaal('close')
            })

        }

    },
    toggleSubMenu() {
        $(document.body).on('click', '.nav-primary__link', function(e){
            e.preventDefault()
            if($(window).width() < 1030 && $(this).hasClass('has-submenu')){
                $(this).toggleClass('active')
                $(this).next('.megamenu').toggleClass('active')
            } else {
                if (!/#/.test($(this).attr('href')) && !$(this).hasClass('has-submenu')) {
                    window.location.replace($(this).attr('href'))
                }
            }
        })
    },
    registerEvents() {
        $(document.body).on('minicartOpen', this.minicartOpen )
        $(document.body).on('minicartClose', this.minicartClose )
    },
    animationsCommon() {
        AOS.init({
            anchorPlacement: 'center-bottom',
            duration: 700,
            easing: 'outexpo',
            delay: 300,
            once: true,
        })
    },
    init() {
        this.registerEvents()
        this.animationsCommon()
        this.toggleSubMenu()
        this.iconBurger()
        this.headerFunctions()
        this.cookiesPopup()
        this.minicartUpdateQty()
        this.modalPromo()
        this.mobileMenu()
        this.onOrder()
        this.qtyButton()
    },
    finalize() {

    },
}
